module.exports = __webpack_public_path__ + "img/CAT.033b380e.jpeg";